import React, { useState, useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Container, Nav, Form, InputGroup } from "react-bootstrap";
import { Menu, User, Search, Heart } from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  const [openId, setOpenId] = useState(null);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };

  return (
    <>
      {/* MAIN HEADER */}

      <header className="custom-header-wrapper">
        <div className="custom-topbar">
          <div className="container-fluid px-md-5 px-3">
            <div className="custom-topbar-inner">
              <p>Make Every Gift Unforgettable With Personalization</p>

              <Link to="/enquiry-form" className="enquiry-btn text-decoration-none">
                Bulk Enquiry
              </Link>
            </div>
          </div>
        </div>

        <div className="custom-header-main-layer py-3">
          <Container fluid className="px-md-5 px-3">
            <div className="custom-header-flex">
              {/* LEFT */}
              <div className="custom-header-left">
                <Link to="/" className="custom-header-logo">
                  <img src={config?.logo} alt="logo" />
                </Link>
              </div>

              <div className="custom-header-right">
                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#shoppingCartCanvas"
                  className="custom-header-link bg-transparent border-0 p-0 d-block d-md-none"
                >
                  CART ({cartItems.length})
                </button>
                <Link
                  to="/wishlist"
                  className="d-md-none d-block text-decoration-none custom-header-link"
                >
                  <Heart size={20} />
                </Link>

                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                  className="custom-mobile-menu-btn d-lg-none"
                >
                  <Menu size={24} />
                </button>
              </div>

              <div className="custom-header-center d-none d-lg-flex">
                <Nav>
                  <Nav.Link as={Link} to="/" className="custom-nav-item">
                    Home
                  </Nav.Link>
                  <div className="custom-nav-dropdown">
                    <Nav.Link as={Link} to="/#" className="custom-nav-item">
                      About{" "}
                      <i
                        className="fas fa-chevron-down ms-1"
                        style={{ fontSize: "10px" }}
                      ></i>
                    </Nav.Link>

                    {/* Dropdown Menu for About */}
                    <div className="custom-dropdown-menu">
                      <Link to="/about-us" className="custom-dropdown-item">
                        About Us
                      </Link>
                      <Link to="/blog" className="custom-dropdown-item">
                        Blogs
                      </Link>
                      <Link to="/shop" className="custom-dropdown-item">
                        Shop
                      </Link>
                    </div>
                  </div>
                  {categories.map((cat) => (
                    <div className="custom-nav-dropdown" key={cat._id}>
                      <Nav.Link
                        as={Link}
                        to={`/categories/${cat.slugPath}`}
                        className="custom-nav-item"
                      >
                        {cat.name}
                      </Nav.Link>

                      {cat.children && cat.children.length > 0 && (
                        <div className="custom-dropdown-menu">
                          {cat.children.map((sub) => (
                            <Link
                              key={sub._id}
                              to={`/categories/${sub.slugPath}`}
                              className="custom-dropdown-item"
                            >
                              {sub.name}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                  <Nav.Link
                    as={Link}
                    to="/contact-us"
                    className="custom-nav-item"
                  >
                    Contact
                  </Nav.Link>
                </Nav>
              </div>

              {/* RIGHT */}
              <div className="custom-header-right">
                <div className="custom-header-search-box d-none d-lg-block">
                  <InputGroup className="border-bottom border-dark">
                    <Form.Control
                      placeholder="Search gifts and hampers ..."
                      className="border-0 shadow-none header-search-input"
                      value={searchText}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        setShowSearchModal(true);
                      }}
                    />
                    <Search size={18} className="search-icon" />
                  </InputGroup>
                  <SearchCanvas
                    isOpen={showSearchModal}
                    searchText={searchText}
                    setSearchText={setSearchText}
                  />
                </div>

                <Link
                  to="/wishlist"
                  className="d-md-block d-none text-decoration-none custom-header-link"
                >
                  <Heart size={20} />
                </Link>

                <div className="d-none d-lg-block">
                  {isLoggedIn ? (
                    <Link to="/users/dashboard" className="custom-header-link">
                      <User size={20} />
                    </Link>
                  ) : (
                    <Link to="/users/login" className="custom-header-link">
                      <User size={20} />
                    </Link>
                  )}
                </div>

                <button
                  data-bs-toggle="offcanvas"
                  data-bs-target="#shoppingCartCanvas"
                  className="custom-header-link bg-transparent border-0 p-0 d-none d-md-block"
                >
                  CART ({cartItems.length})
                </button>
              </div>
            </div>
          </Container>
        </div>
        <div className="custom-header-search-box d-block d-lg-none p-3 bg-muted">
          <InputGroup className="border-bottom border-dark">
            <Form.Control
              placeholder="Search gifts and hampers..."
              className="border-0 shadow-none header-search-input"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setShowSearchModal(true);
              }}
            />
            <Search size={18} className="search-icon" />
          </InputGroup>
          <SearchCanvas
            isOpen={showSearchModal}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </div>
      </header>

      <div
        className="offcanvas offcanvas-end custom-cart-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>

      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <button
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
        <div className="mb-canvas-content">
          <div className="mb-body">
            <div className="mb-content-top">
              <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                <li className="nav-mb-item">
                  <Link to="/" className="mb-menu-link text-decoration-none">
                    Home
                  </Link>
                </li>

                {/* 2. ABOUT DROPDOWN (Toggleable) */}
                <li className="nav-mb-item">
                  <div
                    className="mb-menu-link d-flex justify-content-between align-items-center"
                    onClick={() => handleToggle("about-mb")}
                    style={{ cursor: "pointer" }}
                  >
                    About
                    {/* Symbol wala part yahan sahi kiya gaya hai */}
                    <span className="plus-minus-icon">
                      {openId === "about-mb" ? "-" : "+"}
                    </span>
                  </div>

                  {openId === "about-mb" && (
                    <div className="dropdown-menu show border-0 ps-2 bg-transparent">
                      <Link to="/about-us" className="dropdown-item py-2">
                        About Us
                      </Link>
                      <Link to="/blog" className="dropdown-item py-2">
                        Blogs
                      </Link>
                      <Link to="/shop" className="dropdown-item py-2">
                        Shop
                      </Link>
                    </div>
                  )}
                </li>

                {categories.map((cat) => (
                  <li className="nav-mb-item" key={cat._id}>
                    <div
                      className="mb-menu-link nav-item-dropdown d-flex justify-content-between"
                      onClick={() => handleToggle(cat._id)}
                    >
                      {cat.name}
                      <span>{openId === cat._id ? "-" : "+"}</span>
                    </div>
                    {cat.children?.length > 0 && openId === cat._id && (
                      <div className="dropdown-menu show border-0 ps-2 bg-transparent">
                        {cat.children.map((sub) => (
                          <Link
                            key={sub._id}
                            to={`/categories/${sub.slugPath}`}
                            className="dropdown-item"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </li>
                ))}
                <li className="nav-mb-item">
                  <Link to="/contact-us" className="mb-menu-link">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mb-other-content">
              <div className="group-icon">
                {!isLoggedIn ? (
                  <Link to="/users/login" className="shop-btn">
                    <i className="icon icon-user me-2" /> Login
                  </Link>
                ) : (
                  <Link to="/users/dashboard" className="shop-btn">
                    <i className="icon icon-user me-2" /> Dashboard
                  </Link>
                )}
              </div>
              <div className="mb-contact mb-0 border-bottom border-muted">
                <p>
                  Address:
                  <span className="ms-1">
                    {[
                      config?.address?.addressLine,
                      config?.address?.district,
                      config?.address?.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {config?.address?.pincode
                      ? ` - ${config?.address.pincode}`
                      : ""}
                  </span>
                </p>
              </div>
              <ul className="pt-3">
                <li>
                  Email:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`mailto: ${config.email}`}
                    >
                      {config.email}
                    </a>
                  </b>
                </li>
                <li>
                  Phone:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`tel: ${config.phone}`}
                    >
                      +91-{config.phone}
                    </a>
                  </b>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
